import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth/store';
import config from './modules/config/store';
import user from './modules/user/store';
import polls from './modules/polls/store';
import stats from './modules/stats/store';
import data from './modules/data/store';
import marketplace from './modules/marketplace/store';

Vue.use(Vuex);

export default new Vuex.Store({
	strict: false,
	modules: {
		auth,
		config,
		data,
		marketplace,
		polls,
		stats,
		user,
	}
});



// WEBPACK FOOTER //
// ./src/store.js